module.exports = __webpack_public_path__ + "img/meme_10.805444fb.jpg";